import './_collection-hatbox-product-grid.scss';

export default () => {};
